import Devices from "@/modules/device/devices/store";
import DeviceConfigurations from "@/modules/device/deviceConfigurations/store";

export default { modules: [Devices, DeviceConfigurations] };
